import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ChatState {
  activeChatId: number | undefined
  scopeId: number | undefined
  currentSpaceId: number | undefined
}

const initialState: ChatState = {
  activeChatId: undefined,
  scopeId: undefined,
  currentSpaceId: undefined
}

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setActiveChatId: (state, action: PayloadAction<number | undefined>) => {
      state.activeChatId = action.payload
    },
    setScopeId: (state, action: PayloadAction<number | undefined>) => {
      const newScopeId = action.payload
      if (newScopeId !== state.scopeId) {
        state.scopeId = newScopeId
        state.activeChatId = undefined
      }
    },
    setCurrentSpaceId: (state, action: PayloadAction<number | undefined>) => {
      const newSpaceId = action.payload
      if (newSpaceId !== state.currentSpaceId) {
        state.currentSpaceId = newSpaceId
      }
    }
  }
})

export const { setActiveChatId, setScopeId, setCurrentSpaceId } = chatSlice.actions
export default chatSlice.reducer
